module.exports = __webpack_public_path__ + "img/1 (53).affc118a.png";